module.exports = __webpack_public_path__ + "static/media/shape1_6.9c118631.obj";